import React from "react";
import Konva from "konva";
import { Placement } from "@floating-ui/react";
import DatePicker from "frontend/ui-components/date-picker";
import styles from "./date-picker.module.css";
import { KonvaPicker } from "./konva-picker";

type DatePickerProps = {
  konvaNode: Konva.Node | null;
  stage: Konva.Stage | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedDate: Date | undefined;
  onSelect: (date: Date) => void;
  buttonRef: React.RefObject<Konva.Node>;
  side?: Placement;
};

export function MondayDatePicker({
  konvaNode,
  stage,
  open,
  onOpenChange,
  selectedDate,
  onSelect,
  buttonRef,
  side = "bottom-start",
}: DatePickerProps) {
  const handleDateSelect = (date: Date) => {
    onSelect(date);
    onOpenChange(false);
  };

  return (
    <KonvaPicker
      konvaNode={konvaNode}
      stage={stage}
      open={open}
      onOpenChange={onOpenChange}
      buttonRef={buttonRef}
      side={side}
      className={styles.picker}
      role="dialog"
    >
      <DatePicker selected={selectedDate} onSelected={handleDateSelect} />
    </KonvaPicker>
  );
}
